module.exports = __webpack_public_path__ + "images/bannerDE-a4223f49b91d14816963db365339067c.png";